import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Credit from './Credit';
import Debit from './Debit';
import InstantPay from './InstantPay';

const TransactionRequest = () => {
  const location = useLocation();
 
  const [activeTab, setActiveTab] = useState("credit");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const currentTab = (queryParams.get('currentTab') || '').toLowerCase().trim();

    const tabMap = {
      credit: 'credit',
      debit: 'debit',
      quickpay: 'instantaneous',
      quick_pay: 'instantaneous',
      instantpay: 'instantaneous',
      instantaneous: 'instantaneous',
      payid: 'instantaneous'
    };

    const mappedTab = tabMap[currentTab];
    if (mappedTab) {
      setActiveTab(mappedTab);
    }
  }, [location.search]);

  const tabs = [
    {
      id: "credit",
      label: "Credit",
      component: <Credit />
    },
    {
      id: "debit",
      label: "Debit",
      component: <Debit />
    },
    {
      id: "instantaneous",
      label: "Quick Pay",
      component: <InstantPay />
    }
 
  ];

  // return (
  //   <div className="min-h-screen bg-gray-50 p-4">
  //     <div className="max-w-7xl mx-auto">
  //       <div className="bg-white rounded-lg shadow-sm">
  //         <div className="p-6 border-b">
  //           <h1 className="text-2xl font-bold text-center text-gray-800">
  //             Transaction Request
  //           </h1>
  //           <div className="flex justify-center mt-4">
  //             <button
  //               onClick={() => setActiveTab('credit')}
  //               className={`px-4 py-2 mx-2 ${activeTab === 'credit' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'} rounded-md`}
  //             >
  //               Credit Request
  //             </button>
  //             <button
  //               onClick={() => setActiveTab('debit')}
  //               className={`px-4 py-2 mx-2 ${activeTab === 'debit' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'} rounded-md`}
  //             >
  //               Debit Request
  //             </button>
  //           </div>
  //         </div>
  //         <div className="p-6">
  //           {activeTab === 'credit' ? <Credit /> : <Debit />}
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <div className="pt-4 lg:min-w-[79vw] lg:max-w-[80vw]">
      <div className="p-4 bg-white border-radius-10 text-left">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold text-gray-800">Transaction Request</h1>
        </div>

        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === tab.id
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {tabs.find(tab => tab.id === activeTab)?.component}
        </div>
      </div>
    </div>
  );
};

export default TransactionRequest;
